import React, { useState, useEffect } from "react";
import Pagination from "@material-ui/lab/Pagination";

import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    raiz: {
        position: 'relative',
        paddingBottom: '2rem',
        '& .MuiCard-root':{
            '@media screen and (max-width: 959px)': {
                maxHeight: "none !important",
                height: "auto !important",
                paddingBottom: '30px',
            }
        }
        
    },
    paginacion: {
        width: '100%', 
        display: 'flex', 
        justifyContent: 'center'
    }
}));

export const withPagination = (ComponenteEnvuelto: any, tamano: number) => {
    
    return (props: any) => {
        const classes = useStyles(props);

        const [resultadosPorPagina, setResultadosPorPagina] = useState<any[]>([]);
        const [pagina, setPagina] = useState(1);
        
        const manejarCambioDePagina = (paginaActual: number) => {
            setPagina(paginaActual);
            setResultadosPorPagina(props.resultados.slice((paginaActual - 1) * tamano, ((paginaActual - 1) * tamano) + tamano));   
        }

        const numeroDePaginas = () => {
            return  Math.ceil((props.resultados.length / tamano));;
        }

        useEffect(() => {
            const resultadosPaginaInicial = props.resultados.slice((pagina - 1) * tamano, ((pagina - 1) * tamano) + tamano);
            setResultadosPorPagina(resultadosPaginaInicial);
        }, [props.resultados])
            
        return (
            <div className={classes.raiz}>
                <ComponenteEnvuelto resultados={resultadosPorPagina} error={props.error} texto={props.texto} />
                {numeroDePaginas() > 1 && resultadosPorPagina?.length > 0 &&
                    <Pagination
                        className={classes.paginacion}
                        count={numeroDePaginas()}
                        defaultPage={1}
                        page={pagina}
                        shape="rounded"
                        size="small"
                        // @ts-ignore
                        onChange={(e: any, value: number) => manejarCambioDePagina(value)}
                    />
                }
            </div>
        )
    }
}